import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store/'

import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'

import * as VueGoogleMaps from 'vue2-google-maps'

import GmapCluster from 'vue2-google-maps/dist/components/cluster' // replace src with dist if you have Babel issues
import './registerServiceWorker'

Vue.component('GmapCluster', GmapCluster)

Vue.use(VuejsDialog)
// Vue.use(Viewer)
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBXHTApQxC7eBOhAUSi5kiniwnOdztCyKY',
    region: 'RO',
    language: 'ro'
  }
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
